
import React from 'react';
import { FileImage } from 'lucide-react';
import { CompressionResult } from '@/types/imageFile';

interface FileInfoSectionProps {
  fileName: string;
  fileSize: number;
  compression?: CompressionResult;
  isPremium?: boolean;
}

const FileInfoSection = ({ fileName, fileSize, compression, isPremium = false }: FileInfoSectionProps) => {
  const formatFileSize = (bytes: number) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
  };

  return (
    <div className="flex items-start gap-3 mb-3">
      <FileImage className={`w-5 h-5 mt-0.5 flex-shrink-0 ${
        isPremium ? 'text-purple-500' : 'text-blue-500'
      }`} />
      <div className="min-w-0 flex-1">
        <h3 className="font-medium text-gray-800 truncate" title={fileName}>
          {fileName}
        </h3>
        <div className="text-sm text-gray-500 mt-1 space-y-1">
          <div>Original: {formatFileSize(fileSize)}</div>
          {compression && (
            <>
              <div className={isPremium ? 'text-purple-600' : 'text-green-600'}>
                Comprimida: {formatFileSize(compression.compressedSize)}
              </div>
              <div className={isPremium ? 'text-purple-600' : 'text-blue-600'}>
                Reducción: {compression.compressionRatio.toFixed(1)}%
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default FileInfoSection;
